var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "nonum_box" },
    [
      _c("div", { staticClass: "nonum_left" }, [
        _c(
          "div",
          {
            staticClass: "two_mod",
            staticStyle: { "margin-bottom": "0.15rem" },
          },
          [
            _vm._m(0),
            _c(
              "div",
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: 1 },
                    model: {
                      value: _vm.obj.desire,
                      callback: function ($$v) {
                        _vm.$set(_vm.obj, "desire", $$v)
                      },
                      expression: "obj.desire",
                    },
                  },
                  [_vm._v("整体预算优先")]
                ),
                _c(
                  "el-radio",
                  {
                    attrs: { label: 2 },
                    on: { click: _vm.goToInquiry },
                    model: {
                      value: _vm.obj.desire,
                      callback: function ($$v) {
                        _vm.$set(_vm.obj, "desire", $$v)
                      },
                      expression: "obj.desire",
                    },
                  },
                  [_vm._v("按照我的标准来")]
                ),
              ],
              1
            ),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "one_mod",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("b", [_vm._v("亲，保证为您完成任务。咱们的目的地是？")]),
            _c("city-autocomplete", {
              attrs: { obj: _vm.obj, sizeType: "small", action: false },
              on: { handleSelect: _vm.handleSelect },
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.destination.length > 0,
                expression: "destination.length>0",
              },
            ],
            staticClass: "two_mod",
          },
          [
            _c("div", { staticClass: "p_tag cleanFloat" }, [
              _c("span", [_vm._v("亲，您选的是：")]),
              _c(
                "p",
                _vm._l(_vm.destination, function (tag, ind) {
                  return _c(
                    "el-tag",
                    {
                      key: tag.id,
                      attrs: { closable: "", size: "small" },
                      on: {
                        close: function ($event) {
                          return _vm.handleClose(_vm.destination, ind)
                        },
                      },
                    },
                    [_vm._v(_vm._s(tag.cityName))]
                  )
                }),
                1
              ),
            ]),
            _vm._m(1),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.obj.desire === 1,
                expression: "obj.desire ===1",
              },
            ],
            staticClass: "three_mod",
          },
          [
            _c(
              "p",
              [
                _c("b", [_vm._v("预估出行人数：")]),
                _c("el-input-number", {
                  attrs: { min: 0, max: 99999, label: "成人数", size: "small" },
                  model: {
                    value:
                      _vm.obj.inquiryMaintainList[0].estimatedTravelAdultNum,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.obj.inquiryMaintainList[0],
                        "estimatedTravelAdultNum",
                        $$v
                      )
                    },
                    expression:
                      "obj.inquiryMaintainList[0].estimatedTravelAdultNum",
                  },
                }),
                _c("span", [_vm._v("成人")]),
                _c("el-input-number", {
                  attrs: { min: 0, max: 99999, label: "儿童数", size: "small" },
                  model: {
                    value:
                      _vm.obj.inquiryMaintainList[0]
                        .estimatedTravelAdultChildren,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.obj.inquiryMaintainList[0],
                        "estimatedTravelAdultChildren",
                        $$v
                      )
                    },
                    expression:
                      "obj.inquiryMaintainList[0].estimatedTravelAdultChildren",
                  },
                }),
                _c("span", [_vm._v("儿童")]),
              ],
              1
            ),
            _c(
              "p",
              [
                _c("b", [_vm._v("预估出行日期：")]),
                _c("el-date-picker", {
                  attrs: {
                    "value-format": "yyyy-MM-dd",
                    size: "small",
                    "unlink-panels": true,
                    type: "daterange",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                  },
                  model: {
                    value: _vm.travelDate,
                    callback: function ($$v) {
                      _vm.travelDate = $$v
                    },
                    expression: "travelDate",
                  },
                }),
                _c("span", [
                  _vm._v(_vm._s(_vm.getBetweenDay(_vm.travelDate)) + "天"),
                ]),
              ],
              1
            ),
            _c(
              "p",
              { staticClass: "budgetClass" },
              [
                _c("b", [_vm._v("预算：")]),
                _c("el-input", {
                  staticStyle: { width: "1rem", "margin-right": "0.05rem" },
                  attrs: { placeholder: "单人预算", size: "small" },
                  on: {
                    input: function ($event) {
                      _vm.obj.inquiryMaintainList[0].price =
                        _vm.obj.inquiryMaintainList[0].price.replace(
                          /[^\d]/g,
                          ""
                        )
                    },
                  },
                  model: {
                    value: _vm.obj.inquiryMaintainList[0].price,
                    callback: function ($$v) {
                      _vm.$set(_vm.obj.inquiryMaintainList[0], "price", $$v)
                    },
                    expression: "obj.inquiryMaintainList[0].price",
                  },
                }),
                _c("currency-autocomplete", {
                  attrs: {
                    obj: _vm.obj.inquiryMaintainList[0],
                    sizeType: "small",
                  },
                }),
                _c(
                  "span",
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.obj.inquiryMaintainList[0].type,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.obj.inquiryMaintainList[0],
                              "type",
                              $$v
                            )
                          },
                          expression: "obj.inquiryMaintainList[0].type",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 0 } }, [
                          _vm._v("不含机票"),
                        ]),
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("含经济舱"),
                        ]),
                        _c("el-radio", { attrs: { label: 2 } }, [
                          _vm._v("含公务/头等舱"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.obj.inquiryMaintainList[0].type &&
                      _vm.obj.inquiryMaintainList[0].type !== 0,
                    expression:
                      "obj.inquiryMaintainList[0].type&&obj.inquiryMaintainList[0].type!==0",
                  },
                ],
              },
              [
                _c("b", [_vm._v("出发地：")]),
                _c("city-autocomplete", {
                  attrs: { obj: _vm.departurePlace, sizeType: "small" },
                }),
              ],
              1
            ),
            _c("p", [
              _vm._v(" 亲 您这是私家团？还是企业出行？ "),
              _c(
                "span",
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 1 },
                      on: { change: _vm.changeType },
                      model: {
                        value: _vm.obj.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.obj, "type", $$v)
                        },
                        expression: "obj.type",
                      },
                    },
                    [_vm._v("私家团")]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 2 },
                      on: { change: _vm.changeType },
                      model: {
                        value: _vm.obj.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.obj, "type", $$v)
                        },
                        expression: "obj.type",
                      },
                    },
                    [_vm._v("企业出行")]
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.obj.type === 1,
                expression: "obj.type ===1",
              },
            ],
            staticClass: "private_mod label_mod",
          },
          [
            _c("div", [
              _c("b", [_vm._v("行程期待：")]),
              _c(
                "p",
                [
                  _c(
                    "el-checkbox-group",
                    {
                      attrs: { size: "mini" },
                      model: {
                        value: _vm.expectArr,
                        callback: function ($$v) {
                          _vm.expectArr = $$v
                        },
                        expression: "expectArr",
                      },
                    },
                    _vm._l(_vm.expectList, function (lab) {
                      return _c(
                        "el-checkbox-button",
                        { key: lab, attrs: { label: lab } },
                        [_vm._v(_vm._s(lab))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", [
              _c("b", [_vm._v("出游主题：")]),
              _c(
                "p",
                [
                  _c(
                    "el-checkbox-group",
                    {
                      attrs: { size: "mini" },
                      model: {
                        value: _vm.themeArr,
                        callback: function ($$v) {
                          _vm.themeArr = $$v
                        },
                        expression: "themeArr",
                      },
                    },
                    _vm._l(_vm.themeList, function (lab) {
                      return _c(
                        "el-checkbox-button",
                        { key: lab, attrs: { label: lab } },
                        [_vm._v(_vm._s(lab))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.obj.type === 2,
                expression: "obj.type ===2",
              },
            ],
            staticClass: "enterprise_mod label_mod",
          },
          [
            _c("div", [
              _c("b", [_vm._v("所需服务：")]),
              _c(
                "p",
                [
                  _c(
                    "el-checkbox-group",
                    {
                      attrs: { size: "mini" },
                      model: {
                        value: _vm.serviceArr,
                        callback: function ($$v) {
                          _vm.serviceArr = $$v
                        },
                        expression: "serviceArr",
                      },
                    },
                    _vm._l(_vm.serviceList, function (lab) {
                      return _c(
                        "el-checkbox-button",
                        { key: lab, attrs: { label: lab } },
                        [_vm._v(_vm._s(lab))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.obj.type,
                expression: "obj.type",
              },
            ],
            staticClass: "label_mod",
          },
          [
            _c("div", [
              _c("b", [_vm._v("预算内包含的项目：")]),
              _c(
                "p",
                { staticStyle: { display: "block" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      attrs: { size: "mini" },
                      model: {
                        value: _vm.projectArrOne,
                        callback: function ($$v) {
                          _vm.projectArrOne = $$v
                        },
                        expression: "projectArrOne",
                      },
                    },
                    _vm._l(
                      _vm.obj.type === 1
                        ? _vm.projectListOne
                        : _vm.projectListTwo,
                      function (lab) {
                        return _c(
                          "el-checkbox-button",
                          { key: lab, attrs: { label: lab } },
                          [_vm._v(_vm._s(lab))]
                        )
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("el-input", {
              attrs: { placeholder: "您的别的要求" },
              model: {
                value: _vm.obj.inquiryMaintainList[0].customerMessage,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.obj.inquiryMaintainList[0],
                    "customerMessage",
                    $$v
                  )
                },
                expression: "obj.inquiryMaintainList[0].customerMessage",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "nonum_right" }, [
        _vm._m(2),
        _c("div", { staticClass: "demand_summary" }, [
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.destination.length > 0,
                  expression: "destination.length>0",
                },
              ],
            },
            [
              _vm._v("亲，这次准备前往的目的地是： "),
              _vm._l(_vm.destination, function (city, ind) {
                return _c("b", { key: ind }, [
                  _vm._v(_vm._s(city.cityName)),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: ind < _vm.destination.length - 1,
                          expression: "ind<destination.length-1",
                        },
                      ],
                    },
                    [_vm._v("、")]
                  ),
                ])
              }),
            ],
            2
          ),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.destination.length > 0,
                  expression: "destination.length>0",
                },
              ],
            },
            [
              _vm._v(
                "一个人的行走范围，就是他的世界。——北岛《青灯》。我们在世界里见证生命的丰富~"
              ),
            ]
          ),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.obj.desire,
                  expression: "obj.desire",
                },
              ],
            },
            [
              _vm._v("您想要"),
              _c("b", [
                _vm._v(_vm._s(_vm.obj.desire === 1 ? "整体预算优先" : "")),
              ]),
              _vm._v("哦~~~木有问题！"),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.obj.desire,
                  expression: "obj.desire",
                },
              ],
            },
            [
              _c("p", [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.obj.inquiryMaintainList[0]
                            .estimatedTravelAdultNum > 0 ||
                          _vm.obj.inquiryMaintainList[0]
                            .estimatedTravelAdultChildren > 0,
                        expression:
                          "obj.inquiryMaintainList[0].estimatedTravelAdultNum>0||obj.inquiryMaintainList[0].estimatedTravelAdultChildren>0",
                      },
                    ],
                  },
                  [
                    _vm._v(" 亲，您这次的出行计划一共有 "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.obj.inquiryMaintainList[0]
                                .estimatedTravelAdultNum > 0,
                            expression:
                              "obj.inquiryMaintainList[0].estimatedTravelAdultNum>0",
                          },
                        ],
                      },
                      [
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm.obj.inquiryMaintainList[0]
                                .estimatedTravelAdultNum
                            )
                          ),
                        ]),
                        _vm._v("个成人"),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.obj.inquiryMaintainList[0]
                                .estimatedTravelAdultChildren > 0,
                            expression:
                              "obj.inquiryMaintainList[0].estimatedTravelAdultChildren>0",
                          },
                        ],
                      },
                      [
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm.obj.inquiryMaintainList[0]
                                .estimatedTravelAdultChildren
                            )
                          ),
                        ]),
                        _vm._v("个小朋友"),
                      ]
                    ),
                  ]
                ),
                _c("span", [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.travelDate != "",
                          expression: "travelDate!=''",
                        },
                      ],
                    },
                    [
                      _vm._v(" 预计"),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.travelDate[0]) +
                            " 至 " +
                            _vm._s(_vm.travelDate[1])
                        ),
                      ]),
                      _vm._v("一共"),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.getBetweenDay(_vm.travelDate)) + "天"
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.obj.inquiryMaintainList[0].price,
                          expression: "obj.inquiryMaintainList[0].price",
                        },
                      ],
                    },
                    [
                      _vm._v("每个人预算"),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.obj.inquiryMaintainList[0].price) +
                            _vm._s(_vm.obj.inquiryMaintainList[0].currency)
                        ),
                      ]),
                      _vm._v("以内"),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            (_vm.obj.inquiryMaintainList[0].type &&
                              _vm.obj.inquiryMaintainList[0].type != 0) ||
                            (_vm.obj.type === 0 &&
                              _vm.projectArrOne.length > 0),
                          expression:
                            "obj.inquiryMaintainList[0].type&&obj.inquiryMaintainList[0].type!=0||obj.type===0&&projectArrOne.length>0",
                        },
                      ],
                    },
                    [
                      _c(
                        "b",
                        [
                          _vm._v(" 包含 "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.obj.inquiryMaintainList[0].type == 1 ||
                                    _vm.obj.inquiryMaintainList[0].type == 2,
                                  expression:
                                    "obj.inquiryMaintainList[0].type==1||obj.inquiryMaintainList[0].type==2",
                                },
                              ],
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.obj.inquiryMaintainList[0].type == 1
                                      ? "经济舱机票"
                                      : "公务/头等舱机票"
                                  ) +
                                  _vm._s(
                                    _vm.projectArrOne.length > 0 ? "、" : ""
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._l(_vm.projectArrOne, function (lab, ind) {
                            return _c("span", { key: lab }, [
                              _vm._v(_vm._s(lab)),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: ind < _vm.projectArrOne.length - 1,
                                      expression: "ind<projectArrOne.length-1",
                                    },
                                  ],
                                },
                                [_vm._v("、")]
                              ),
                            ])
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.departurePlace.cityName &&
                            _vm.departurePlace.cityName != "" &&
                            _vm.obj.inquiryMaintainList[0].type !== 0,
                          expression:
                            "departurePlace.cityName&&departurePlace.cityName!=''&&obj.inquiryMaintainList[0].type!==0",
                        },
                      ],
                    },
                    [
                      _c("b", [
                        _vm._v(
                          "，从" +
                            _vm._s(_vm.departurePlace.cityName) +
                            "出发。"
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.obj.type === 1,
                      expression: "obj.type===1",
                    },
                  ],
                },
                [
                  _c("p", [
                    _vm._m(3),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.expectArr.length > 0 ||
                              _vm.themeArr.length > 0,
                            expression: "expectArr.length>0||themeArr.length>0",
                          },
                        ],
                      },
                      [
                        _vm._v(",希望 "),
                        _vm._l(_vm.expectArr, function (lab, ind) {
                          return _c("b", { key: lab }, [
                            _vm._v(_vm._s(lab)),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      ind < _vm.expectArr.length - 1 ||
                                      _vm.themeArr.length > 0,
                                    expression:
                                      "ind<expectArr.length-1||themeArr.length>0",
                                  },
                                ],
                              },
                              [_vm._v("、")]
                            ),
                          ])
                        }),
                        _vm._l(_vm.themeArr, function (lab, ind) {
                          return _c("b", { key: lab }, [
                            _vm._v(_vm._s(lab)),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: ind < _vm.themeArr.length - 1,
                                    expression: "ind<themeArr.length-1",
                                  },
                                ],
                              },
                              [_vm._v("、")]
                            ),
                          ])
                        }),
                        _vm._v(" ~~的旅程 "),
                      ],
                      2
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.obj.type === 2,
                      expression: "obj.type===2",
                    },
                  ],
                },
                [
                  _c("p", [
                    _vm._m(4),
                    _c(
                      "span",
                      [
                        _vm._v("，需要的服务涉及到"),
                        _vm._l(_vm.serviceArr, function (lab, ind) {
                          return _c("b", { key: lab }, [
                            _vm._v(_vm._s(lab)),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: ind < _vm.serviceArr.length - 1,
                                    expression: "ind<serviceArr.length-1",
                                  },
                                ],
                              },
                              [_vm._v("、")]
                            ),
                          ])
                        }),
                        _vm._v("。"),
                      ],
                      2
                    ),
                  ]),
                ]
              ),
              _vm.obj.type
                ? _c("div", [
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.obj.inquiryMaintainList[0].customerMessage !=
                              "",
                            expression:
                              "obj.inquiryMaintainList[0].customerMessage!=''",
                          },
                        ],
                      },
                      [
                        _vm._v(" 您希望"),
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm.obj.inquiryMaintainList[0].customerMessage
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c("p", [
                      _vm._v(
                        "好嘞！ 上述信息全部收到! 您的这些需求，我们在为您推荐行程和产品的时候都会考虑到滴，保证让您满意！"
                      ),
                    ]),
                    _c("div", { staticClass: "btnBox" }, [
                      _c("button", { on: { click: _vm.sendInquiry } }, [
                        _vm._v("请尽快给我提供与我的预算匹配的产品方案"),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
      ]),
      _c("send-inquiry-dialog", {
        ref: "sendInquiry",
        attrs: { identity: "定制师" },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "p_text" }, [
      _c("p", [
        _vm._v("您是希望整体预算优先，让定制师按照 "),
        _c("span", [_vm._v("整体预算优先")]),
      ]),
      _c("p", [
        _vm._v("为您推荐符合您预算的产品呢？还是您需要整体 "),
        _c("span", [_vm._v("产品标准优先")]),
        _vm._v("，"),
      ]),
      _c("p", [_vm._v("让定制师以您的标准和预算帮您推荐商品？")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "p_text" }, [
      _c("p", [_vm._v(" 好的，你的目的地收到！")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "nr_title" }, [
      _c("i"),
      _c("span", [_vm._v("您的产品需求 ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [_vm._v("咱们是"), _c("b", [_vm._v("私人出行")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [_vm._v("咱们是"), _c("b", [_vm._v("企业出行")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }